var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main-header'),_c('lesson',{attrs:{"coursesslug":_vm.$route.params.coursesslug,"lessonsslug":_vm.$route.params.lessonsslug,"type":"blackboard"}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }